module.exports = __webpack_public_path__ + "d9e18951801ede64575b5968e751ca4a.png";